import { useField } from 'formik';
import { Box, MenuItem, TextField, InputLabel } from '@mui/material';

import { QuestionLabel } from 'components/question-label';
import {
  SelectFormField,
  FormChoiceResponse,
  FormChoiceResponseType,
  FORM_OTHER_OPTION_VALUE,
} from 'types';

import { InputField } from '../fields';

export const FormSelectField = ({
  id,
  label,
  options,
  required,
  placeholder,
}: SelectFormField) => {
  const [field, , helpers] = useField<
    FormChoiceResponse | FormChoiceResponse[] | null
  >(id);
  const responses = Array.isArray(field.value)
    ? field.value
    : field.value
      ? [field.value]
      : [];
  const otherResponse = responses.find(
    (response) => response.type === FormChoiceResponseType.OTHER
  );
  const controlValue = responses.map((response) =>
    response.type === FormChoiceResponseType.OTHER
      ? FORM_OTHER_OPTION_VALUE
      : response.value
  );

  return (
    <Box className="flex flex-col gap-2">
      <InputLabel component="div" className="mb-2" required={required}>
        <QuestionLabel value={label} />
      </InputLabel>
      <InputField
        select
        name={id}
        fullWidth
        required={required}
        placeholder={placeholder}
        displayValue={options?.multiple ? controlValue : controlValue[0]}
        slotProps={{
          select: {
            multiple: options?.multiple,
          },
        }}
        mapSelectValue={(value) =>
          value === FORM_OTHER_OPTION_VALUE ? 'Other' : value
        }
        mapValue={(selectedValue) => {
          const selectedValues = Array.isArray(selectedValue)
            ? selectedValue
            : [selectedValue];
          const nextResponses = selectedValues.map((value) =>
            value === FORM_OTHER_OPTION_VALUE
              ? {
                  value: otherResponse?.value ?? '',
                  type: FormChoiceResponseType.OTHER,
                }
              : { value, type: FormChoiceResponseType.OPTION }
          );
          return options?.multiple ? nextResponses : (nextResponses[0] ?? null);
        }}
      >
        {options &&
          options.options.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        {options?.allowOther && (
          <MenuItem value={FORM_OTHER_OPTION_VALUE}>Other</MenuItem>
        )}
      </InputField>
      {options?.allowOther && otherResponse && (
        <TextField
          fullWidth
          label="Other"
          value={otherResponse.value}
          placeholder="Enter another response"
          onChange={(event) => {
            const nextOtherResponse: FormChoiceResponse = {
              value: event.target.value,
              type: FormChoiceResponseType.OTHER,
            };
            helpers.setValue(
              Array.isArray(field.value)
                ? [
                    ...field.value.filter(
                      (response) =>
                        response.type !== FormChoiceResponseType.OTHER
                    ),
                    nextOtherResponse,
                  ]
                : nextOtherResponse,
              true
            );
          }}
        />
      )}
    </Box>
  );
};
